<template>
  <div class="center-horizontal">
    <div style="position: relative">
      <div class="number-ball">
        <p
          class="bold"
          style="margin-top: 25% !important; margin-bottom: 25% !important"
        >
          {{ number }}
        </p>
      </div>
      <div>
        <img
          :src="
            ios
              ? require(`@/assets/img/howToIOS/${img}`)
              : require(`@/assets/img/howToAndroid/${img}`)
          "
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { number: String, img: String, ios: Boolean },
};
</script>

<style scoped>
img {
  margin-bottom: 0.5em;
  width: 16vw;
  box-shadow: rgba(0, 0, 0, 1) 0px 0px 15px, rgba(0, 0, 0, 1) 0px 0px 15px;
}

.number-ball {
  font-size: clamp(9px, 1vw, 22px);
  position: absolute;
  left: -3em;
  top: 50%;
  bottom: 50%;
}

@media (max-width: 992px) {
  img {
    width: 60vw;
  }
}
</style>
